import * as Core from '@skylab-shared/core';

export class AccountingOnlineReceiverModel extends Core.ModelBase {
    @Core.Property({ identifiable: true })
    public id: string;

    @Core.Property()
    public channelId: string;

    @Core.Property()
    public password: string;

    @Core.Property()
    public name: string;
}
